import { render, staticRenderFns } from "./ResultsCalculation.vue?vue&type=template&id=f38aa952"
import script from "./ResultsCalculation.vue?vue&type=script&lang=ts"
export * from "./ResultsCalculation.vue?vue&type=script&lang=ts"
import style0 from "./ResultsCalculation.vue?vue&type=style&index=0&id=f38aa952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports